import { render, staticRenderFns } from "./AbsentExamsWidget.vue?vue&type=template&id=cffc52b0"
import script from "./AbsentExamsWidget.vue?vue&type=script&lang=js"
export * from "./AbsentExamsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports